import { IClauseType } from "@/api";
import { Chip, Stack } from "@mui/material";

interface IProps {
    clauseTypes: IClauseType[];
}

export const ClauseTypesCell = ({ clauseTypes }: IProps) => {
    return (
        <Stack direction={"row"} flexWrap={"wrap"} gap={1}>
            {clauseTypes.map(({ name }, index) => (
                <Chip
                    key={`clauseType-${name}-${index}`}
                    label={name}
                    size={"small"}
                    color={"tertiary"}
                />
            ))}
        </Stack>
    );
};
